<template>
  <div class="position-relative dinA4">
    <img :src="require('@/assets/carga-header.png')" class="mb-6 page__header" />
    <div class="page__container">
      <div class="d-flex align-center mb-12">
        <img class="img-contain product-icon" :src="require('@/assets/carga-icon.png')" />
        <div class="d-flex flex-column ml-6">
          <p class="red-title red-title--bold mb-2">Os seus envios Carga</p>
          <p class="body-1 justify-text">
            <b>Cobertura ibérica:</b> Serviço de entrega prevista nas 24h seguintes ao dia útil da sua recolha (Portugal Continental).
          </p>
          <p class="body-1 justify-text mt-2">
            <b>Disponível na oferta:</b> Carga.
          </p>
        </div>
      </div>
    </div>

    <Footer logo :page="previousPages + 1" />
  </div>
</template>

<script>
import Footer from '@/containers/offer-form/sign-off/pdf-venta-directa-2026-pt-nexus/Footer'

export default {
  name: 'CargaIntro',
  components: { Footer },
  data() {
    return {
      previousPages: 0,
    }
  },
  mounted() {
    this.previousPages = this.$parent.sectionPreviousPages('CargaIntro')
  },
}
</script>
